module.exports = __webpack_public_path__ + "img/member_card_bottom_shadow_1.28690c4b.png";